/**
 * @module app.shared
 */

import { convertToString } from "app/shared/lib/utilities";

export class PropertyValueConverter {

    public toView(value: unknown, key: unknown): any {
        // no value, return value
        if(value === null || value === undefined) {
            return value;
        }

        const keyString = convertToString(key);

        // no key, return value
        if(keyString.length === 0) {
            return value;
        }

        const keyParts = keyString.split('.');
        if(Array.isArray(value)) {
            return value.map(item => this.getValue(item, keyParts));
        }
        return this.getValue(value, keyParts);

    }

    private getValue(value: unknown, keyParts: string[]): unknown {
        if(typeof value === 'object') {
            let current: any = value;
            for(let keyPart of keyParts) {
                if(current === null || current === undefined)
                    return undefined;
                current = current[keyPart];
            }
            return current;
        }
        // all other types, return as-is
        return value;
    }

}
